import { Business } from '@app/domain/Business'
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core'
import { Customer } from '@app/domain/Customer'
import { DateTime } from 'luxon'
import { Subject, finalize, takeUntil } from 'rxjs'
import { Venue } from '@app/domain/Venue'
import { BookingsFeedbackReportData } from '@app/features/reports/domain/BookingsFeedbackReportData'
import {
    BookingsFeedbackReportService,
} from '@app/features/reports/services/bookings-feedback-report.service'

@Component({
    selector: 'app-customer-feedback-list',
    templateUrl: './customer-feedback-list.component.html',
})
export class CustomerFeedbackListComponent implements OnChanges, OnDestroy {

    @Input() business!: Business
    @Input() venue!: Venue
    @Input() customer!: Customer
    isLoading = false
    rows: BookingsFeedbackReportData[] = []
    readonly feedbackCommentPreviewLength = 240
    expandedFeedbackCommentIds = new Set<string>()
    protected readonly DateTime = DateTime
    private onDestroy = new Subject<void>()

    constructor(
        private bookingsFeedbackReportService: BookingsFeedbackReportService,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['business'] || changes['venue'] || changes['customer']) {
            this.loadCustomerFeedback()
        }
    }

    ngOnDestroy() {
        this.onDestroy.next()
        this.onDestroy.complete()
    }

    toggleFeedbackComment(feedbackId: string) {
        if (this.expandedFeedbackCommentIds.has(feedbackId)) {
            this.expandedFeedbackCommentIds.delete(feedbackId)
            return
        }
        this.expandedFeedbackCommentIds.add(feedbackId)
    }

    private loadCustomerFeedback() {
        if (!this.business || !this.venue || !this.customer) {
            this.rows = []
            return
        }
        this.rows = []
        this.isLoading = true
        this.bookingsFeedbackReportService.fetchCustomerData(
            this.business.id,
            this.venue.id,
            this.customer.id
        )
            .pipe(
                takeUntil(this.onDestroy),
                finalize(() => this.isLoading = false)
            )
            .subscribe(rows => {
                this.rows = rows
                this.expandedFeedbackCommentIds.clear()
            })
    }
}
